import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell
} from 'recharts';
import './Charts.css';
import { formatIndianCurrency, formatChartAxis } from '../../../utils/currencyFormatter';

const SalesByHourChart = ({ data }) => {
  const getColorForHour = (hour) => {
    const hourNum = parseInt(hour.split(':')[0]);
    if (hourNum >= 11 && hourNum <= 14) return '#f59e0b'; // Lunch
    if (hourNum >= 18 && hourNum <= 21) return '#ef4444'; // Dinner
    return '#3b82f6'; // Normal
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="tooltip-label">{payload[0].payload.hour}</p>
          <p className="tooltip-value">
            Revenue: <strong>{formatIndianCurrency(payload[0].value, true, 2)}</strong>
          </p>
          <p className="tooltip-sub">Orders: {payload[0].payload.orders}</p>
          <p className="tooltip-sub">Customers: {payload[0].payload.customers}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="chart-container">
      <h3 className="chart-title">Hourly Sales Pattern</h3>
      <div className="chart-legend">
        <span className="legend-item">
          <span className="legend-dot" style={{ background: '#3b82f6' }}></span>
          Regular
        </span>
        <span className="legend-item">
          <span className="legend-dot" style={{ background: '#f59e0b' }}></span>
          Lunch Rush
        </span>
        <span className="legend-item">
          <span className="legend-dot" style={{ background: '#ef4444' }}></span>
          Dinner Rush
        </span>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis 
            dataKey="hour" 
            stroke="#6b7280"
            style={{ fontSize: '11px' }}
            interval={2}
          />
          <YAxis 
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
            tickFormatter={(value) => formatChartAxis(value)}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="revenue" radius={[4, 4, 0, 0]}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={getColorForHour(entry.hour)} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SalesByHourChart;

